<template>
  <!--  优惠券选择框  -->
  <el-dialog
    :visible.sync="showCouponDialog"
    custom-class="couponDialog"
    :show-close="false"
    :width="`${width}px`"
    :close-on-click-modal="closeOnOther"
    :close-on-press-escape="closeOnOther"
    @close="close()"
    top="20vh"
    center
  >
    <div id="couponDialog">
      <img
        class="close"
        v-if="closeBtnShow"
        src="@/assets/image/AccountDeal/close.png"
        alt=""
        @click="close()"
      />
      <div class="coupon-dialog-title" v-if="title">
        {{ title }}
      </div>
      <div class="content">
        <div
          :class="[
            'coupon-item',
            chooseItem && chooseItem.id == v.id
              ? 'couponItem-checked'
              : 'couponItem-unchecked',
          ]"
          v-for="(v, k) in couponList"
          :key="k"
          @click="chooseCoupon(v)"
        >
          <div class="left">
            <span class="name">{{ v.coupon_name }}</span>
            <span class="time">{{ v.validate_stop_time }} 到期</span>
            <span class="use-range">{{ v.use_range | useRangeFormatter}}</span>
          </div>
          <div class="right">
            <span class="amount"
              ><span class="icon">¥</span><span>{{ Number(v.amount).toFixed(0) }}</span></span
            >
            <span class="limit">满{{ Number(v.threshold).toFixed(0) }}元可用</span>
          </div>
        </div>
      </div>
      <div class="operate">
        <div class="cancel" @click="cancel">取消</div>
        <div class="confirm" @click="confirm">确认</div>
      </div>
    </div>
  </el-dialog>
</template>

  <script>
export default {
  name: "couponDialog",
  props: {
    couponList: {
      type: Array,
      default() {
        return [];
      },
    },
    // currentChoose: {
    //   type: Object,
    //   default() {
    //     return {};
    //   },
    // },
    title: {
      type: String,
      default: "",
    },
    text: {
      type: String,
      default: "",
    },
    btn: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      Number,
      default: "358",
    },
    closeBtnShow: {
      type: Boolean,
      default: true,
    },
    closeOnOther: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showCouponDialog: false,
      chooseItem: this.couponList[0],
    };
  },
  filters: {
    useRangeFormatter(value) {
      switch (value) {
          case 1:
          return "全部游戏可用";
          case 2:
          return "部分游戏可用";
          case 3:
          return "部分账号商品可用";
          default:
            break;
        }
      if (!value) return '';
    }
  },
  methods: {
    chooseCoupon(item) {
      if (this.chooseItem !== item) {
        this.chooseItem = item;
      }else{
        this.chooseItem = {}
      }
    },
    close() {
      this.showCouponDialog = false;
    },
    showDialog(item) {
      this.showCouponDialog = true;
      this.$nextTick(() => {
        if(item!={}){
            this.chooseItem = item;
        }
      });
    },
    cancel() {
      this.showCouponDialog = false;
    },
    confirm() {
      this.showCouponDialog = false;
      this.$parent.ChooseCouponNow(this.chooseItem);
    },
  },
  watch: {
    show(val) {
      this.showCouponDialog = val;
    },
  },
  mounted() {},
};
</script>

  <style lang="less" scoped>
/deep/.el-dialog__header,
/deep/.el-dialog__body {
  padding: 0 !important;
}
/deep/.couponDialog {
  overflow: visible;
  border-radius: 4px;
  box-shadow: none;
  background: var(--bg-card, #FFFFFF);
  filter: drop-shadow(0 18px 46px rgba(26, 29, 36, 0.14));

  .el-dialog__body {
    background: var(--bg-card, #FFFFFF);
    border-radius: 4px;
  }

  #couponDialog {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    background: var(--bg-card, #FFFFFF);
    border-radius: 4px;

    .coupon-dialog-title {
      box-sizing: border-box;
      width: 100%;
      min-height: 26px;
      margin: 26px 0 0;
      padding: 0 34px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 18px;
      font-family: PingFang SC-Semibold, PingFang SC;
      font-weight: 600;
      color: var(--text-main, #111827);
      line-height: 24px;
      text-align: center;
    }

    .content {
      box-sizing: border-box;
      width: calc(100% - 68px);
      height: 390px;
      margin: 20px 34px 18px;
      padding: 0 8px 0 0;
      overflow-y: auto;
      font-size: 13px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: var(--text-secondary, #5A5F6B);

      &::-webkit-scrollbar {
        width: 6px;
      }

      &::-webkit-scrollbar-thumb {
        background: var(--border-strong, #CBD5E1);
        border-radius: 4px;
      }

      &::-webkit-scrollbar-track {
        background: var(--bg-section, #F7F5F2);
        border-radius: 4px;
      }

      .coupon-item {
        position: relative;
        box-sizing: border-box;
        width: 100%;
        min-height: 108px;
        margin: 0 0 12px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        overflow: hidden;
        background: #FFFFFF;
        border: 1px solid var(--border-soft, #E8E4DE);
        border-radius: 4px;
        cursor: pointer;
        transition: background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
      }

      .coupon-item::before,
      .coupon-item::after {
        position: absolute;
        left: calc(100% - 142px);
        z-index: 1;
        width: 16px;
        height: 16px;
        content: "";
        background: var(--bg-card, #FFFFFF);
        border: 1px solid var(--border-soft, #E8E4DE);
        border-radius: 50%;
      }

      .coupon-item::before {
        top: -9px;
      }

      .coupon-item::after {
        bottom: -9px;
      }

      .coupon-item:hover {
        background: #FFFFFF;
        border-color: rgba(255, 122, 26, 0.24);
        box-shadow: 0 8px 18px rgba(255, 122, 26, 0.08);
      }

      .couponItem-checked {
        background: #FFFFFF;
        border-color: rgba(255, 122, 26, 0.38);
        box-shadow: 0 8px 18px rgba(255, 122, 26, 0.10);
      }

      .couponItem-checked::before,
      .couponItem-checked::after {
        border-color: rgba(255, 122, 26, 0.38);
      }

      .couponItem-checked .right {
        background: var(--primary-soft, #FFF3E7);
      }

      .couponItem-checked .name {
        color: var(--text-main, #111827);
      }

      .couponItem-checked .right::after {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 38px;
        height: 31px;
        content: "";
        background: url("../../../assets/image/Coupon/chooseTag.png") no-repeat center / cover;
      }

      .left {
        min-width: 0;
        flex: 1 1 auto;
        align-self: stretch;
        box-sizing: border-box;
        padding: 16px 18px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        background: linear-gradient(180deg, #FFFFFF 0%, var(--bg-section, #F7F5F2) 100%);

        .name {
          max-width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 17px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          color: var(--text-main, #111827);
          line-height: 24px;
        }

        .time {
          margin: 8px 0 0;
          font-size: 13px;
          color: var(--text-secondary, #5A5F6B);
          line-height: 20px;
        }

        .use-range {
          margin: 6px 0 0;
          padding: 2px 8px;
          background: #FFFFFF;
          border: 1px solid var(--border-soft, #E8E4DE);
          border-radius: 4px;
          font-size: 13px;
          color: var(--brand-blue, #1A1D24);
          line-height: 18px;
        }
      }

      .right {
        position: relative;
        flex: 0 0 132px;
        align-self: stretch;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 16px 14px;
        background: linear-gradient(180deg, #FFF7ED 0%, var(--primary-soft, #FFF3E7) 100%);
        border-left: 1px dashed rgba(255, 122, 26, 0.35);

        .amount {
          font-size: 34px;
          font-family: PingFang SC, PingFang SC-Semibold;
          font-weight: 600;
          color: var(--primary, #FF7A1A);
          line-height: 40px;

          .icon {
            font-size: 14px;
            margin-right: 4px;
          }
        }

        .limit {
          margin: 4px 0 0;
          color: var(--text-muted, #9AA0AC);
          font-size: 12px;
          line-height: 18px;
        }
      }
    }

    .close {
      position: absolute;
      z-index: 2;
      width: 30px;
      height: 30px;
      bottom: -42px;
      left: calc(50% - 15px);
      opacity: .92;
      cursor: pointer;
      transition: opacity .2s ease, transform .2s ease;
    }

    .close:hover {
      opacity: 1;
      transform: rotate(90deg);
    }
  }

  .operate {
    display: flex;
    justify-content: center;
    gap: 12px;
    padding: 0 34px 26px;

    .cancel,
    .confirm {
      width: 150px;
      height: 40px;
      box-sizing: border-box;
      border-radius: 3px;
      font-size: 15px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 500;
      text-align: center;
      line-height: 40px;
      cursor: pointer;
      transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
    }

    .cancel {
      color: var(--text-main, #1A1D24);
      background: #FFFFFF;
      border: 1.5px solid var(--bg-dark, #1A1D24);
    }

    .cancel:hover {
      color: var(--text-main, #1A1D24);
      border-color: var(--bg-dark, #1A1D24);
      background: var(--bg-tag, #F0EDE8);
    }

    .confirm {
      color: #FFFFFF;
      background: var(--primary, #FF5A1F);
      border: 1px solid transparent;
    }

    .confirm:hover {
      background: var(--primary-hover, #E84A12);
      box-shadow: 0 10px 22px rgba(255, 90, 31, 0.22);
    }
  }
}
</style>
